import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=4b9b71c7&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=4b9b71c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9b71c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b9b71c7')) {
      api.createRecord('4b9b71c7', component.options)
    } else {
      api.reload('4b9b71c7', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=4b9b71c7&scoped=true&", function () {
      api.rerender('4b9b71c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8fdbsM39x2cfq/JS/comp/PopupDialog.vue"
export default component.exports